/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validators_UrlInputs */

const en_validators_url = /** @type {(inputs: Validators_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a valid URL (https://...).`)
};

const de_validators_url = /** @type {(inputs: Validators_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie eine gültige URL ein (https://...).`)
};

/**
* | output |
* | --- |
* | "Please enter a valid URL (https://...)." |
*
* @param {Validators_UrlInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const validators_url = /** @type {((inputs?: Validators_UrlInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validators_UrlInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validators_url(inputs)
	return de_validators_url(inputs)
});